import classnames from "classnames";
import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import RoleName from 'enums/RoleName';
import User from 'interfaces/User';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import isInRole from "utils/isInRole";
import UserDataTable from "./../common/UserDataTable";


interface State {
    isLoading: boolean;
    isSubmitting: boolean;
    hasValidationErrors: boolean;
    errorMessage?: string;
    users: User[];
    indexesSelected: number[];
    searchString: string;
    originalUsers: User[];
    showSearchInput: boolean;
    currentPage: number,
    usersPerPage: number,
    totalLength: number,
    indexOfFirstUser: number,
    indexOfLastUser: number,
    isLast: boolean,
    isFirst: boolean
}

export default class Add extends React.Component<RouteComponentProps<{}>, State> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            isSubmitting: false,
            hasValidationErrors: false,
            errorMessage: undefined,
            users: [],
            indexesSelected: [],
            searchString: "",
            originalUsers: [],
            showSearchInput: false,
            currentPage: 1,
            usersPerPage: 10,
            totalLength: -1,
            indexOfFirstUser: -1,
            indexOfLastUser: -1,
            isLast: false,
            isFirst: false,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.previousHandler = this.previousHandler.bind(this);
        this.nextHandler = this.nextHandler.bind(this);
        this.perPageHandler = this.perPageHandler.bind(this);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleCheckboxSelected = this.handleCheckboxSelected.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading topOffset={350} />
                </div>
            );
        }
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.totalLength / this.state.usersPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <li
                    className={classnames("page-item", {
                        active: number === this.state.currentPage
                    })}
                    key={number}
                    id={number.toString()}
                    onClick={event => this.handlePageClick(event, number)}
                >
                    <a className="page-link" href="javascript:void(0)">
                        {number}
                    </a>
                </li>
            );
        });

        const linkStyle = {
            cursor: 'pointer',
        } as React.CSSProperties

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink to="/users">Users</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Add New Users</BreadcrumbLink>
                </Breadcrumb>
                <div className="card card--form">
                    <div className="card-block">
                        <h3 className="block-title">Add New Users</h3>
                        {this.state.hasValidationErrors && (
                            <DangerAlert name="dangerAlert">
                                {this.state.errorMessage || "An error occurred."}
                            </DangerAlert>
                        )}
                        <div className="table-action">
                            <div className="dataTables_filter">
                                <label>
                                    <span className="search-icon" onClick={() => this.setState({ showSearchInput: !this.state.showSearchInput })}></span>
                                    <input
                                        type="search"
                                        value={this.state.searchString}
                                        onChange={this.handleSearch}
                                        className="form-control input-sm"
                                        style={{ display: (this.state.showSearchInput ? 'block' : 'none') }}
                                    />
                                </label>
                            </div>
                            <div className="dataTables_length">
                                <select
                                    className="form-control input-sm"
                                    value={this.state.usersPerPage}
                                    onChange={this.perPageHandler}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                        <form className="form" onSubmit={this.handleFormSubmit}>
                            <UserDataTable data={this.state.users} onCheckboxChanged={this.handleCheckboxSelected}
                                onDropdownChanged={(event, index) => this.handleRoleChanged(event, index)} />

                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-center text-center">
                                    <ul className="pagination">
                                        {this.state.currentPage !== 1 ? (
                                            <li className="page-item" onClick={this.previousHandler}>
                                                <a className="page-link" style={linkStyle}>Previous</a>
                                            </li>
                                        ) : null}
                                        {renderPageNumbers}
                                        {!this.state.isLast ? (
                                            <li className="page-item" onClick={this.nextHandler}>
                                                <a className="page-link" style={linkStyle}>Next</a>
                                            </li>
                                        ) : null}
                                    </ul>
                                </div>

                            </div>

                            <div className="form-actions">
                                <div className="text-center">
                                    {this.state.isSubmitting
                                        ? <button type="submit" className="btn btn-primary" disabled><i className="icon-spinner icon-pulse"></i> Saving</button>
                                        : <button type="submit" className="btn btn-primary">Save</button>
                                    }
                                </div>
                            </div>
                        </form>

                    </div>
                </div>

            </div>
        </div>;
    }

    public componentWillMount() {
        if (isInRole(RoleName.Admin)) {
            return true;
        }

        this.props.history.push("/users");
        return false;
    }

    public async componentDidMount() {
        await this.getData();
    }

    public async getData() {
        let indexOfLastUser = this.state.currentPage * this.state.usersPerPage;
        let indexOfFirstUser = indexOfLastUser - this.state.usersPerPage;

        let response = await apifetch("users/addlocaladusers", undefined, true);

        if (response.ok) {
            let data = await response.json() as User[];
            for (let i = 0; i < data.length; i++) {
                data[i].roleId = 1;
            }

            let currentUsers = data.slice(
                indexOfFirstUser,
                indexOfLastUser
            );

            this.setState({
                isLoading: false,
                users: currentUsers,
                originalUsers: data,
                currentPage: Number(this.state.currentPage),
                indexOfFirstUser: indexOfFirstUser,
                indexOfLastUser: indexOfLastUser,
                totalLength: data.length
            });

            document.title = "Add Users - " + SITE_NAME;
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                isLoading: false,
                hasValidationErrors: true,
                errorMessage: errorText,
            });
        }
    }
    private async handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.setState({
            isSubmitting: true,
            hasValidationErrors: false,
            errorMessage: undefined,
        });

        let data: User[] = [];
        for (let i = 0; i < this.state.indexesSelected.length; i++) {
            data.push(this.state.users[this.state.indexesSelected[i]]);
        }

        let response = await apifetch("users", {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json",
            }),
            method: "POST",
            body: JSON.stringify(data),
        }, true);
        if (response.ok) {
            this.props.history.push("/users");
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                isSubmitting: false,
                hasValidationErrors: true,
                errorMessage: errorText,
            });
        }
    }

    private handleCheckboxSelected(event: React.FormEvent<HTMLInputElement>) {
        let value = parseInt(event.currentTarget.value, 10);

        if (event.currentTarget.checked) {
            if (this.state.indexesSelected.indexOf(value) === -1) {
                this.state.indexesSelected.push(value);
            }
        } else {
            let index = this.state.indexesSelected.indexOf(value);
            if (index !== -1) {
                this.state.indexesSelected.splice(index, 1);
            }
        }
    }

    private handleInputChanged(event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleRoleChanged(event: React.ChangeEvent<HTMLSelectElement>, index: number) {
        let users = this.state.users;
        users[index].roleId = parseInt(event.currentTarget.value, 10);

        this.setState({
            users: users,
        });
    }

    private handleSearch = (event: React.FormEvent<HTMLInputElement>) => {
        event.preventDefault();

        if (event.currentTarget.value) {
            let filtered = this.state.originalUsers.filter(item => {
                return (
                    item.username.toLowerCase().includes(event.currentTarget.value.toLowerCase()) ||
                    (item.name != null && item.name.toLowerCase().includes(event.currentTarget.value.toLowerCase())) ||
                    (item.email != null && item.email.toLowerCase().includes(event.currentTarget.value.toLowerCase()))
                );
            });
            this.setState({
                searchString: event.currentTarget.value,
                users: filtered
            });
        } else {
            this.setState({
                users: this.state.originalUsers,
                searchString: ""
            });
            setTimeout(() => {
                this.getData();;
            }, 50);
        }
    };

    private handlePageClick = (event: React.MouseEvent<HTMLLIElement>, id: number) => {
        event.preventDefault();

        let indexOfLastUser = id * this.state.usersPerPage;
        let indexOfFirstUser = indexOfLastUser - this.state.usersPerPage;
        let currentUsers = this.state.originalUsers.slice(
            indexOfFirstUser,
            indexOfLastUser
        );

        let isLast = true;
        let result = Number(id) * this.state.usersPerPage;
        if (this.state.totalLength > result) {
            isLast = false;
        } else {
            isLast = true;
        }

        this.setState({
            currentPage: Number(id),
            indexOfLastUser: indexOfLastUser,
            indexOfFirstUser: indexOfFirstUser,
            users: currentUsers,
            isLast: isLast
        });
    };

    private nextHandler = (event: React.MouseEvent<HTMLLIElement>) => {
        event.preventDefault();
        let indexOfLastUser =
            (this.state.currentPage + 1) * this.state.usersPerPage;
        let indexOfFirstUser = indexOfLastUser - this.state.usersPerPage;
        let currentUsers = this.state.originalUsers.slice(
            indexOfFirstUser,
            indexOfLastUser
        );

        let isLast = true;
        let result = (this.state.currentPage + 1) * this.state.usersPerPage;
        if (this.state.totalLength > result) {
            isLast = false;
        } else {
            isLast = true;
        }

        this.setState({
            currentPage: Number(this.state.currentPage) + 1,
            indexOfLastUser: indexOfLastUser,
            indexOfFirstUser: indexOfFirstUser,
            users: currentUsers,
            isLast: isLast
        });
    };

    private previousHandler = (event: React.MouseEvent<HTMLLIElement>) => {
        event.preventDefault();
        let indexOfLastUser =
            (this.state.currentPage - 1) * this.state.usersPerPage;
        let indexOfFirstUser = indexOfLastUser - this.state.usersPerPage;
        let currentUsers = this.state.originalUsers.slice(
            indexOfFirstUser,
            indexOfLastUser
        );

        this.setState({
            currentPage: Number(this.state.currentPage) - 1,
            indexOfLastUser: indexOfLastUser,
            indexOfFirstUser: indexOfFirstUser,
            users: currentUsers,
            isLast: false
        });
    };

    private perPageHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();

        let indexOfLastUser = 1 * Number(event.currentTarget.value);
        let indexOfFirstUser = indexOfLastUser - Number(event.currentTarget.value);
        let currentUsers = this.state.originalUsers.slice(
            indexOfFirstUser,
            indexOfLastUser
        );
        this.setState({
            ...this.state,
            usersPerPage: Number(event.currentTarget.value),
            users: currentUsers
        });
    };
}



// WEBPACK FOOTER //
// ./ClientApp/components/users/Add.tsx